import { useEffect } from 'react';
import '../App.css';
import { useNavigate } from "react-router-dom";
import * as User from '../slices/userSlice';
import * as Cases from '../slices/casesSlice';
import * as UI from '../slices/uiSlice';
import { useAppDispatch } from '../slices/index';
import { AnyAction } from 'redux';

const Logout = () => {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();

	useEffect(() => {
		const clrcases = () => new Promise((resolve) => resolve(dispatch((Cases.clrCases()) as unknown as AnyAction)));
		const closeMenu = () => new Promise((resolve) => resolve(dispatch((UI.closeMenu()) as unknown as AnyAction)));
		const logout = () => new Promise((resolve) => resolve(dispatch((User.userLogout()) as unknown as AnyAction)));
		dispatch(User.doUserLogout() as unknown as AnyAction);
		clrcases().then(() => closeMenu().then(() => logout().then(() => {
			document.cookie = "accessToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
			navigate('/');
		})));
	}, []);

	return (
		<div className="centered">
			<img src={require('../assets/bricks.gif')} style={{ width: 67, height: 34 }} alt='Bricks-Gif' />
		</div>
	);
}

export default Logout;